module.exports = __webpack_public_path__ + "fa61982ab18c626bc0a37e61d3f878cd.jpg";